import React from 'react';

import './css/theme.css';

import {RecoilRoot} from 'recoil';
import Cookies from "js-cookie";
import {customerKeyExists} from "./utils/requestUtils";
import AppRouter from "./AppRouter";
import {createRoot} from "react-dom/client";
import {PermissionProvider} from "./core/PermissionContext";

const AUTOCADASTRO_STEP_PATHS = new Set([
    'documentos', 'endereco', 'contato', 'sobre', 'fim', 'linkInvalido', 'nome',
]);

const pathParts = window.location.pathname.split('/').filter(Boolean);
const autocadastroIndex = pathParts.indexOf('autocadastro');

if (autocadastroIndex >= 0 && pathParts.length > autocadastroIndex + 1) {
    const segment = pathParts[autocadastroIndex + 1];
    const customerKeyFromUrl = segment === 'crianca' || AUTOCADASTRO_STEP_PATHS.has(segment)
        ? Cookies.get('customerKey')
        : segment;

    if (customerKeyFromUrl) {
        const response = await customerKeyExists(customerKeyFromUrl);
        if (response?.valid) {
            Cookies.set('customerKey', customerKeyFromUrl);
        } else if (AUTOCADASTRO_STEP_PATHS.has(segment) || segment === 'crianca') {
            Cookies.remove('customerKey');
        }
    }
}

if (window.location.pathname === '/') {
    window.location.pathname = '/app';
}

createRoot(document.getElementById('root')).render(
    <RecoilRoot>
        <PermissionProvider refreshInterval={5 * 60 * 1000}>
            <AppRouter/>
        </PermissionProvider>
    </RecoilRoot>,
);


